<template>
  <div class="contentWrap boxed ">
    <div class="d2-section">
        <div class="d2-section__header">
          <h2 class="d2-h2">
              <span class="text_color"> {{ $t('privacy') }}</span>
            </h2>
          </div>

          <div class="d2-section__content" >
            <span v-if="lang_gamebox == 'arabic'">
              <privacy-arabic/>
            </span>
            <span v-else-if="lang_gamebox == 'malay'">
              <privacy-malay/>
            </span>
            <span v-else-if="lang_gamebox == 'greek'">
              <privacy-greek/>
            </span>
            <span v-else-if="lang_gamebox == 'czech'">
              <privacy-czech/>
            </span>
            <span v-else-if="lang_gamebox == 'bulgarian'">
              <privacy-bulgarian/>
            </span>
            <span v-else-if="lang_gamebox == 'norwegian'">
              <privacy-norwegian/>
            </span>
            <span v-else-if="lang_gamebox == 'swedish'">
                <privacy-swedish/>
            </span>
            <span v-else-if="lang_gamebox == 'finnish'">
              <privacy-finnish/>
            </span>
            <span v-else-if="lang_gamebox == 'romanian'">
              <privacy-romanian/>
            </span>
            <span v-else>
              <privacy-english/>
            </span>
            </div>
      </div>
  </div>
 
</template>


<script>
import PrivacyPolicyEnglish from './PrivacyPolicyEnglish';
import PrivacyPolicyArabic from './PrivacyPolicyArabic';
import PrivacyPolicyMalay from './PrivacyPolicyMalay';
import PrivacyPolicyGreek from './PrivacyPolicyGreek';
import PrivacyPolicyCzech from './PrivacyPolicyCzech';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import PrivacyPolicySwedish from './../PrivacyPolicySwedish';
import PrivacyPolicyFinnish from './PrivacyPolicyFinnish';
import PrivacyPolicyRomanian from './../PrivacyPolicyRomanian';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_gamebox", "country_gamebox"]),
  components:{
    'privacy-english': PrivacyPolicyEnglish,
    'privacy-arabic': PrivacyPolicyArabic,
    'privacy-malay': PrivacyPolicyMalay,
    'privacy-greek': PrivacyPolicyGreek,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian,
    'privacy-swedish': PrivacyPolicySwedish,
    'privacy-romanian': PrivacyPolicyRomanian,
    'privacy-finnish': PrivacyPolicyFinnish
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.privacy_color, .mobiSection__content, .mobitxt{
  color:white !important;
}
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
   
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/PrivacyPolicy.vue